import { deleteApi, getApi, postApi, putApi } from "./http.service";

export const createNewEmployee=async(payload:any)=>{
    return postApi('employee',payload);
}

export const getEmployeeById=async(id:any)=>{
    return getApi('employee/'+id);
}

export const getEmployeesForDevices=async()=>{
    return getApi('employee/devices');
}

export const updateEmployeeById=async(id:any, payload:any)=>{
    return putApi('employee/'+id, payload);
}

export const deleteEmployeeById=async(id:any)=>{
    return deleteApi('employee/'+id);
}